import { Card, Image, Button, Row, Col } from "react-bootstrap";
import styles from "@/styles/Questions.module.scss";

import { decodeHtml } from "@/utils/helpers";
import { useRouter } from "next/router";
import { getStrapiMedia } from "@/utils/media";

const BlogCard = ({ blog, classNameMargin, isMobile }: any) => {

  const blogUrl = `/resources/blog/${blog?.attributes?.Slug}`;
  const mobileView = isMobile <= 800;
  const router = useRouter()
  return (
    <div className={styles.res}>
      <a
        href={blogUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-none"
        onClick={(e) => {
          e.preventDefault();
          if (e?.ctrlKey) {
            window.open(blogUrl, "_blank");
          } else {
            router.push(blogUrl);
          }
        }}
        onContextMenu={(e) => {
          e.stopPropagation(); // Allows browser context menu for links
        }}
      >

        <Card className={`card-blog pointer ${classNameMargin} ${styles.buttonAnimate}`}>{
          mobileView ? <>
            <div className="blog-img-fluid">
              <Image fluid
                src={
                  getStrapiMedia(blog?.attributes?.BannerThumb || blog?.attributes?.Banner) || blog?.attributes?.BannerImageURL || "/assets/images/blog-common.jpg"
                }
                alt={blog?.attributes?.alternativeText || "technologies"}

                className="img-fluid blog-card-img"
                height={blog?.attributes?.Banner?.data?.attributes?.height}
                width={blog?.attributes?.Banner?.data?.attributes?.width}
              />
            </div>
            <Card.Body className="text-blog">
              <Card.Title>{decodeHtml(blog?.attributes?.Title)}</Card.Title>
              <Card.Text>
                item?.Image?.data?.attributes?.url
                {decodeHtml(blog?.attributes?.Content)
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  ?.substring(0, 100)}
                ...
              </Card.Text>
              <Button className="animated-button res-read">Read More</Button>
            </Card.Body>
          </> :
            <>
              <Image fluid
                src={
                  getStrapiMedia(blog?.attributes?.Banner) || blog?.attributes?.BannerImageURL || "/assets/images/blog-common.jpg"
                }
                alt={blog?.attributes?.alternativeText || "technologies"}

                className="img-fluid blog-card-img"
                height={blog?.attributes?.Banner?.data?.attributes?.height}
                width={blog?.attributes?.Banner?.data?.attributes?.width}
              />
              <div className="resource-more-btn">
                <Image
                  src="/assets/icons/link_arrow_white.svg"
                  width={16}
                  height={16}
                  alt="left-down"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </>
        }
          {/* </div>
          <Card.Body className="text-blog">
            <Card.Title>{decodeHtml(blog?.attributes?.Title)}</Card.Title>
            <Card.Text>
              {decodeHtml(blog?.attributes?.Content)
                ?.replace(/<\/?[^>]+(>|$)/g, "")
                ?.substring(0,  400)}
              ...
            </Card.Text>
            <Button className="animated-button res-read">Read More</Button>
          </Card.Body> */}
        </Card>
      </a>

    </div>
  );
};

export default BlogCard;
